import clsx from 'clsx'

export function StatusPill({ value }: { value: string }) {
  const tone =
    ['Published', 'PAID', 'Active', 'DELIVERED', 'Delivered', 'SENT', 'Read'].includes(value)
      ? 'bg-leaf/10 text-leaf-dark'
      : ['Cancelled', 'CANCELLED', 'FAILED', 'Blocked', 'PENDING', 'Inactive', 'Out of Stock'].includes(value)
        ? 'bg-red-50 text-red-700'
        : ['Draft', 'Placed', 'PLACED', 'SCHEDULED', 'Unread'].includes(value)
          ? 'bg-mango-yellow/20 text-[#925d05]'
          : 'bg-stone-100 text-stone-700'

  return (
    <span className={clsx('rounded-full px-2.5 py-1 text-xs font-semibold', tone)}>
      {value.replaceAll('_', ' ')}
    </span>
  )
}
